import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { SeoService } from 'src/app/shareModule/services/seo.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalServiceService } from 'src/app/shareModule/services/local-service.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-product-faq-list',
  templateUrl: './product-faq-list.component.html',
  styleUrl: './product-faq-list.component.scss',
})
export class ProductFaqListComponent implements OnChanges {
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['categoryId']) {
      const prevCategoryId = changes['categoryId'].previousValue;
      const currCategoryId = changes['categoryId'].currentValue;
      if (prevCategoryId != currCategoryId) {
        this._fetchProductSubCategoryFAQInfos();
      }
    }
    if (changes['additionalFAQS']) {
      try {
        this.additionalFAQS = JSON.parse(
          this.additionalFAQS ? this.additionalFAQS : '[]'
        );
      } catch (e) {
        console.error(e);
      }
    }
  }
  public get isPopup(): boolean {
    return (
      this.sharedService.isBrowser() &&
      window.location.href.includes('?product')
    );
  }

  constructor(
    private sharedService: SharedService,
    private auth: AuthServiceService,
    private seoService: SeoService,
    private modalService: NgbModal,
    private local: LocalServiceService,
    private roleService: RoleService,
    private toastr: ToastrService
  ) { }

  public get catFaqExist() {

    const keys = ['questionOne', 'answerOne', 'questionTwo', 'answerTwo', 'questionThree', 'answerThree', 'questionFour', 'answerFour', 'questionFive', 'answerFive']
    let strOn = this.faqInfos && this.faqInfos != 'null' && (
      (typeof this.faqInfos == 'string' && this.faqInfos))

    if (this.faqInfos && typeof this.faqInfos == 'object') {
      for (const key of keys) {
        if (this.faqInfos[key]) {
          return true;
        }
      }
    }
    return strOn
  }
  @Output()
  public faqsExist = new EventEmitter();

  @Input()
  public categoryId: any;

  @Input()
  public additionalFAQS;

  convertBreakline(value?: string) {
    return value?.replace(/\n/g, '<br>');
  }

  public faqInfos = null;
  public productFAQs = [];
  private _fetchCommunityQuestionsAnswers(){
    this.auth.getCommunityFAQQuestionsOfCategory(this.categoryId).subscribe({
      next: data =>{
        this.communityQuestionsAndAnswers = data.body;
      },
      error: console.error
      
    })
  }

  private _fetchProductSubCategoryFAQInfos() {
    if (!(this.categoryId && this.categoryId != -1)) {
      return;
    }
    this._fetchCommunityQuestionsAnswers();
    
    this.auth.getCategoryFAQInfo(this.categoryId).subscribe({
      next: (data: any) => {
        if (!data?.body?.faqInfos) {
          return;
        }
        this.faqInfos = data.body.faqInfos;

        this.faqInfos.answerOne = this.convertBreakline(
          this.faqInfos.answerOne
        );
        this.faqInfos.answerTwo = this.convertBreakline(
          this.faqInfos.answerTwo
        );
        this.faqInfos.answerThree = this.convertBreakline(
          this.faqInfos.answerThree
        );
        this.faqInfos.answerFour = this.convertBreakline(
          this.faqInfos.answerFour
        );
        this.faqInfos.answerFive = this.convertBreakline(
          this.faqInfos.answerFive
        );
        const val = this.catFaqExist || (Array.isArray(this.additionalFAQS) && this.additionalFAQS?.length > 0)
        ////console.log("emitting", val, this.faqInfos)
        //console.log("Emitting exist", val, "others", this.catFaqExist, this.additionalFAQS)

        this.initSchema()
        this.faqsExist.emit(val);
      },
      error: console.error,
    });
  }
  public showFAQ(i) {
    if (this.visibleFAQ[i]) {
      this.visibleFAQ[i] = false;
    } else {
      this.visibleFAQ.fill(false);
      this.visibleFAQ[i] = true;
    }
  }
  public visibleFAQ = new Array(5);
  closeAllFaq() {
    this.visibleFAQ = new Array(5);
  }

  initSchema() {
    const listFAQ = [
      this.faqInfos.questionOne,
      this.faqInfos.questionTwo,
      this.faqInfos.questionThree,
      this.faqInfos.questionFour,
      this.faqInfos.questionFive,
    ]
    const listFAQAnswer = [
      this.faqInfos.answerOne,
      this.faqInfos.answerTwo,
      this.faqInfos.answerThree,
      this.faqInfos.answerFour,
      this.faqInfos.answerFive,
    ]

    ////console.log(listFAQ, listFAQAnswer)
    const schema = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": listFAQ.filter(row => row).map((row, index) => {
        return {
          "@type": "Question",
          "name": row,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": listFAQAnswer[index]
          }
        }
      })
    })

    this.seoService.updateSchema('custom', schema)
  }

  /******************** Code related to asking questions  *************************/
  @ViewChild('askQuestionAboutCategory')
  public askQuestionAboutCategoryModal: TemplateRef<any>;
  

  @ViewChild('answerQuestion')
  public answerQuestionModal: TemplateRef<any>;

  public askQuestionText = '';
  public answerQuestionText = ''
  public answeringQuestion  = null;

  public communityQuestionsAndAnswers = [{
    // text: 'Herro',
    // answers: [
    //   {text: 'hi hi', likeCount: 10, isLiked: false}
    // ]
  }];

  public openAskQuestionsModal(){
    this.askQuestionText = '';
    this.modalService.open(this.askQuestionAboutCategoryModal, {size: 'md'})

  }

  public addAnswerQuestion(){
    this.auth.answerToCommunityFAQQuestion(this.answeringQuestion?.id, this.answerQuestionText).subscribe({
      next: ()=>{
        this.toastr.success("Answer posted");
        this.modalService.dismissAll();
        this._fetchCommunityQuestionsAnswers();

      },
      error: err =>{
        this.toastr.error(err.error.message)
      }
    })

  }
  public openAnswerQuestionModal(question){
    this.answeringQuestion = question;
    this.answerQuestionText = '';
    this.modalService.open(this.answerQuestionModal, {size: 'md'});

  }

  public removeAnswer(answer){
    this.local.confirmYesNo({
      title: 'Are you sure you want to remove this answer',
      text: '',
      icon: 'info'
    }).then(res =>{})

  }
  public get isUserAdmin(): boolean {
    return this.roleService?.roles?.userType.includes('ADMIN')
  } 
  public addQuestionToCategory(){
    this.auth.addCommunityFAQQuestionToCategory(this.categoryId, this.askQuestionText).subscribe({
      next: ()=>{
        this.toastr.success("Question added");
        this._fetchCommunityQuestionsAnswers();
        this.askQuestionText = '';
        this.modalService.dismissAll();
      },
      error: err =>{
        this.toastr.error(err.error.message)
      }
    })
  }
  public removeQuestion(question){
    this.local.confirmYesNo({
      title: 'Are you sure you want to remove this question',
      text: '',
      icon: 'info'
    }).then(res =>{
      if(res.isConfirmed){
        this.auth.removeCommunityFAQQuestionFromCategory(question.id).subscribe({
          next: ()=>{
            this.toastr.success("remove");
            this._fetchCommunityQuestionsAnswers();          
          },
          error: err =>{
            this.toastr.error(err.error.message)
          }
        })
      }
    })
    
  }
  public areAnswerVisisbleCommunityQuestions = [false];

  public toggelViewAnswersToCommunityQuestions(index){
    this.areAnswerVisisbleCommunityQuestions[index] = !this.areAnswerVisisbleCommunityQuestions[index]
  }
  public toggleHeartCommunityQuestion(question){
     this.auth.toggleCommunityFAQQuestionReaction(question.id, 'question').subscribe({
      next :()=>{
        question.isLiked = !question.isLiked
        if(question.isLiked){
          question.likeCount +=1
        }else{
          question.likeCount -= 1
        }

      },
      error: (err)=>{
        this.toastr.error(err.error.message)
      }
     })

  }
  
  public toggleHeartCommunityAnswer(answer){
    this.auth.toggleCommunityFAQQuestionReaction(answer.id, 'answer').subscribe({
      next :()=>{ 
        answer.isLiked = !answer.isLiked
        if(answer.isLiked){
          answer.likeCount +=1
        }else{
          answer.likeCount -= 1
        }

      },
      error: ()=>{
        this.toastr.error("Something went wrong please try again latter")
      }
     })
    
  }
}
